import {Validation} from "@vuelidate/core";
import {Ref} from "vue";

export function errorMessage (validationRule: Validation): string | Ref<string> {
  // @ts-ignore
  return validationRule.$error ? validationRule.$errors[0].$message : "";
}
